import { useEffect, useMemo } from 'react'
import { ROUTES } from 'shared/config/routes'
import { counselorSessionStore } from 'shared/stores/counselorSessionStore'

export const useFooterNavItems = () => {
	const canAccessUserManagement = counselorSessionStore.canAccessUserManagement

	useEffect(() => {
		counselorSessionStore.ensureLoaded().catch(() => {})
	}, [])

	return useMemo(() => {
		const items = []

		if (canAccessUserManagement) {
			items.push({
				to: ROUTES.USER_MANAGEMENT,
				icon: 'manage_accounts',
				label: 'User Management',
				isMaterial: true,
				iconClass: 'userManagementNavIcon',
			})
		}

		items.push({
			to: ROUTES.REPORTS,
			isMaterial: true,
			icon: 'insert_chart_outlined',
			label: 'Reports',
			iconClass: 'compactNavIcon',
		})

		return items
	}, [canAccessUserManagement])
}
